import a from "./1.png";
import b from "./2.png";
import c from "./3.png";

export default { a, b, c };
